import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from 'react'; 
import Login from "./pages/login";
import Home from "./pages/home"; 
import MyProfile from "./pages/my-profile"; 
import PublicProfile from './pages/PublicProfile';
import ChangePassword from "./pages/ChangePassword";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Contact from './pages/Contact';
import About from './pages/About';
import Verifyprofile from './pages/verifyprofile';
import Advertisement from "./pages/Advertisement";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsandConditions from "./pages/TermsandConditions";
import FAQpage from "./pages/Faq"; 
import CMSLoginPage from "./pages/CMSLoginPage";
import DashboardPage from './pages/DashboardPage';
import AdminProtectedRoute from './components/Dashboard/AdminProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import NotFound from "./pages/NotFound";
import NewsListing from './pages/NewsListing';  
import NewsArticle from './pages/NewsArticle';  
import ArticleUpload from "./components/Dashboard/ArticleUpload";
import ArchivePage from './pages/ArchivePage';

function App() {
  return (
    <AuthProvider>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adminlogin" element={<CMSLoginPage />} />
          <Route 
            path="/dashboard" 
            element={
              <AdminProtectedRoute>
                <DashboardPage />
              </AdminProtectedRoute>
            } 
          />
          <Route path="/login" element={<Login />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/Verifyprofile" element={<Verifyprofile />} />
          <Route path="/Advertisement" element={<Advertisement />} />
          <Route path="/Support" element={<Support />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsandConditions" element={<TermsandConditions />} />
          <Route path="/faq" element={<FAQpage />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/profile/:name" element={<PublicProfile />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/ChangePassword" element={<ChangePassword />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
             <Route path="/news" element={<NewsListing />} />
             <Route path="/news/archive/:month" element={<ArchivePage />} />
              <Route path="/articleupload" element={<ArticleUpload />} />
              
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
